import React, {useState} from 'react';
import roomContext from './roomContext';

const RoomState = (props) => {
    const [numberOfRooms, setNumberOfRooms] = useState(0);
    const [numberOfGuest, setNumberOfGuest] = useState(0);
    const [name, setName] = useState(['']);
    const [age, setAge] = useState(['']);
    const [aadhar, setAadhar] = useState(['']);
    const [mobileNumber, setMobileNumber] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState({
        country:"",
        state:"",
        district:"",
        city:"",
        pincode:""
    });
    const [checkInDate, setCheckInDate] = useState('');
    const [checkOutDate, setCheckOutDate] = useState('');
    const [availableRooms, setAvailableRooms] = useState(0); // Store available room
    const [socket, setSocket] = useState(null);

  return (
      <roomContext.Provider value={{
        numberOfRooms, setNumberOfRooms,
        numberOfGuest, setNumberOfGuest,
        name, setName,
        age, setAge,
        aadhar, setAadhar,
        mobileNumber, setMobileNumber,
        email, setEmail,
        address, setAddress,
        checkInDate, setCheckInDate,
        checkOutDate, setCheckOutDate,
        availableRooms, setAvailableRooms,
        socket, setSocket
        }}>
        {props.children}
      </roomContext.Provider>
  )
}

export default RoomState;